import { render, staticRenderFns } from "./grid-view.vue?vue&type=template&id=f8c25c3a&scoped=true"
import script from "./grid-view.vue?vue&type=script&lang=js"
export * from "./grid-view.vue?vue&type=script&lang=js"
import style0 from "./grid-view.vue?vue&type=style&index=0&id=f8c25c3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c25c3a",
  null
  
)

export default component.exports